import homeBlob from "../../assets/images/homepagesvg.svg";
import "./Home.css";
import backgroundBlob from "../../assets/images/background-blob.svg";
import googlePlay from "../../assets/images/google-play-badge-logo.svg";
import appStore from "../../assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg";
import smallBackgroundBlob from "../../assets/images/small-background-blob.svg";

export default function Home() {
  return (
    <div className="">
      {window.innerWidth < 640 ? (
        <img
          className="absolute top-[-1] z-[-1]"
          src={smallBackgroundBlob}
          alt="background svg"
        />
      ) : (
        <img
          className="absolute top-0 z-[-1] "
          src={backgroundBlob}
          alt="background svg"
        />
      )}
      <div className="max-w-6xl mx-auto md:mt-10 mt-6 mb-10 max-lg:mx-4 relative md:grid md:grid-cols-2">
        <div className="md:col-span-1">
          <div className="text-center md:text-left mb-8 md:mb-0">
            <div className="text-[#4e1c4e] font-bold md:text-7xl text-5xl">
              Content Creator?
            </div>
            <div className="text-[#4e1c4e] md:text-7xl md:-my-4 -my-2 text-5xl">
              Receive Gifts
            </div>
            <div className="community-text text-[#4e1c4e] md:text-7xl text-5xl">
              Instantly
            </div>
          </div>
          <div className="text-center md:text-left mb-2 md:mb-0">
            <p className="text-[#4E1C4E] my-2 md:text-lg md:max-w-xl">
              Receive GIFTS directly from followers and viewers. No sharing your
              number, and no hefty platform fees—just seamless MPESA payments.
              Pin your unique payment link on your posts or bio, and get tipped
              instantly with different payment methods.Enjoy a safer and easier
              way to get rewarded!
            </p>
            <div className="flex flex-row gap-2 -mt-4 justify-center md:justify-start">
              <a href="https://play.google.com/store/apps/details?id=com.waiworld.tipserve&pcampaignid=web_share"> <img src={googlePlay} alt="google play" className="w-40" /> </a>
              <img src={appStore} alt="app store" className="w-40" title="Coming Soon!" />
            </div>
          </div>
        </div>
        <div className="md:row-span-1 md:col-start-2 md:col-span-1 relative w-full h-[380px] md:h-full md:absolute md:top-[-10%] md:right-0">
          <img
            className="w-[170%] md:w-[135%] h-auto absolute left-[95%] md:left-auto md:right-[-60%] md:top-0 transform -translate-x-1/2 md:translate-x-0 max-w-none"
            src={homeBlob}
            alt="Landing page"
          />
        </div>
      </div>
    </div>
  );
}
